var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19.369 1.80095L8.42969 12.7406C7.50219 13.6681 5.99843 13.6681 5.07093 12.7406L0.631592 8.30114L1.86903 7.06367L6.30837 11.5031C6.55245 11.7472 6.94818 11.7472 7.19225 11.5031L18.1316 0.563477L19.369 1.80095Z","fill":"#4C4C4C"}));
}

Check.defaultProps = {"width":"20","height":"14","viewBox":"0 0 20 14","fill":"none","className":"icon"};

module.exports = Check;

Check.default = Check;
